import { generateClient } from 'aws-amplify/api';
import { contactsAppSyncConfig } from './config/appsync';

export const client = generateClient({
    authMode: 'userPool',
    endpoint: contactsAppSyncConfig.endpoint,
});

export { contactsAppSyncConfig };
